export const addInsurancePageTranslations = {
  en: {
    addInsurancePage: {
      alert:
        'Adding an insurance card saves you time upon arrival and automatically determines your coverage for this and upcoming visits.',
      confirmOutOfPocket:
        'Without adding insurance you may be fully responsible for your medical bill out-of-pocket.',
      confirmReviewAtAppointment:
        'We will review your insurance at your appointment. Please make sure to bring your card with you.',
      provideCardAtAppointmentQuestion: 'Provide card at appointment?',
      title: 'Would you like to add an insurance card for this appointment?',
    },
  },
  es: {
    addInsurancePage: {
      alert:
        'Agregar una tarjeta de seguro le ahorra tiempo a su llegada y determina automáticamente su cobertura para esta y próximas visitas.',
      confirmOutOfPocket:
        'Sin agregar un seguro, usted puede ser totalmente responsable de pagar su factura médica de su bolsillo.',
      confirmReviewAtAppointment:
        'Revisaremos su seguro en su cita. Por favor asegúrese de traer su tarjeta con usted.',
      provideCardAtAppointmentQuestion: '¿Proporcionar tarjeta en la cita?',
      title: '¿Quiere agregar una tarjeta de seguro para esta cita?',
    },
  },
  ja: {
    addInsurancePage: {
      confirmOutOfPocket:
        '保険を追加しない場合、医療費は全額自己負担となる可能性があります。',
    },
  },
  bn: {
    addInsurancePage: {
      confirmOutOfPocket:
        'বীমা যোগ না করলে, আপনি নিজের চিকিৎসা বিল পরিশোধের ক্ষেত্রে সম্পূর্ণরূপে দায়ী থাকতে পারেন।',
    },
  },
  pt: {
    addInsurancePage: {
      confirmOutOfPocket:
        'Sem adicionar um seguro, você pode ser totalmente responsável pelas suas despesas médicas.',
    },
  },
  ro: {
    addInsurancePage: {
      confirmOutOfPocket:
        'Fără să adăugați asigurare, puteți fi pe deplin responsabil pentru factura medicală din buzunar.',
    },
  },
  ko: {
    addInsurancePage: {
      confirmOutOfPocket:
        '보험을 추가하지 않으면 의료 고지서 본인 부담 비용에 대해 전적으로 본인이 책임져야 할 수 있습니다.',
    },
  },
  zh: {
    addInsurancePage: {
      confirmOutOfPocket: '如果不添加保险，您可能会全额支付医疗费用自付额。',
    },
  },
};
